import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import DownloadsView from "../views/DownloadsView";
import HelpView from "../views/HelpView";
import SubmitView from "../views/SubmitView";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/downloads",
    name: "downloads",
    component: DownloadsView,
  },
  {
    // Download page for the coming CUPP3 release: both the legacy programs and
    // the new merged CUPP3 library.
    path: "/download_cupp3",
    name: "download_cupp3",
    component: () =>
      import(
        /* webpackChunkName: "download_cupp3" */ "../views/DownloadCupp3View.vue"
      ),
  },
  {
    // Per-release list of CUPP3 library DOIs; also serves (via index.html) the
    // manifest that `cupp3-predict -download_lib <VERSION>` parses.
    path: "/library/release",
    name: "library_release",
    component: () =>
      import(
        /* webpackChunkName: "library_release" */ "../views/LibraryReleaseView.vue"
      ),
  },
  {
    path: "/help",
    name: "help",
    component: HelpView,
  },
  {
    path: "/about",
    name: "about",
    component: AboutView,
  },
  {
    path: "/submit",
    name: "submit",
    component: SubmitView,
  },
  {
    // Development/preview page that additionally exposes the CUPP3 prediction
    // method. Intentionally unlinked from the UI — reachable only by direct
    // URL. Will replace /submit upon publication.
    path: "/submit_cupp3",
    name: "submit_cupp3",
    component: () =>
      import(
        /* webpackChunkName: "submit_cupp3" */ "../views/SubmitCupp3View.vue"
      ),
  },
  {
    // CUPP3 de novo clustering (runs on the public BioLib app via the biolib
    // proxy service). Intentionally unlinked — reachable by direct URL only.
    path: "/submit_cluster_cupp3",
    name: "submit_cluster_cupp3",
    component: () =>
      import(
        /* webpackChunkName: "submit_cluster_cupp3" */ "../views/SubmitClusterCupp3View.vue"
      ),
  },
  {
    path: "/cluster_status/:job_id",
    name: "cluster_status",
    component: () =>
      import(
        /* webpackChunkName: "cluster_status" */ "../views/ClusterStatus.vue"
      ),
  },
  {
    path: "/cluster_results/:job_id",
    name: "cluster_results",
    component: () =>
      import(
        /* webpackChunkName: "cluster_results" */ "../views/ClusterResults.vue"
      ),
  },
  {
    path: "/status/:id",
    name: "status",
    component: () =>
      import(/* webpackChunkName: "status" */ "../views/JobStatus.vue"),
  },
  {
    path: "/results/:id",
    name: "results",
    component: () =>
      import(/* webpackChunkName: "results" */ "../views/JobResults.vue"),
  },
  {
    path: "/browse",
    name: "browse",
    component: () =>
      import(/* webpackChunkName: "browse" */ "../views/BrowseView.vue"),
  },
  {
    path: "/query",
    name: "query",
    component: () =>
      import(/* webpackChunkName: "query" */ "../views/QueryView.vue"),
  },
  {
    path: "/browse/cazy",
    name: "browse_cazy",
    component: () =>
      import(/* webpackChunkName: "browse_cazy" */ "../views/BrowseCazy.vue"),
  },
  {
    path: "/browse/cupp",
    name: "browse_cupp",
    component: () =>
      import(/* webpackChunkName: "browse_cupp" */ "../views/BrowseCupp.vue"),
  },
  {
    path: "/browse/ec",
    name: "browse_ec",
    component: () =>
      import(/* webpackChunkName: "browse_ec" */ "../views/BrowseEc.vue"),
  },
  {
    path: "/browse/taxonomy",
    name: "browse_tax",
    component: () =>
      import(/* webpackChunkName: "browse_tax" */ "../views/BrowseTax.vue"),
  },
  {
    path: "/browse/strain",
    name: "browse_stn",
    component: () =>
      import(/* webpackChunkName: "browse_stn" */ "../views/BrowseStn.vue"),
  },
  {
    path: "/browse/genome",
    name: "browse_gen",
    component: () =>
      import(/* webpackChunkName: "browse_gen" */ "../views/BrowseGen.vue"),
  },
  {
    path: "/tree",
    name: "tree",
    component: () =>
      import(/* webpackChunkName: "tree" */ "../views/TreeView.vue"),
  },
  {
    // Previous release of the summary-tree mapping, kept for reference.
    path: "/retired_tree",
    name: "retired_tree",
    component: () =>
      import(
        /* webpackChunkName: "retired_tree" */ "../views/RetiredTreeView.vue"
      ),
  },
  {
    path: "/tree/:pfam",
    name: "tree_redirect",
    component: () =>
      import(
        /* webpackChunkName: "tree_redirect" */ "../views/TreeRedirect.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
